import CInput from "./input";
export default CInput;
